// extracted by mini-css-extract-plugin
module.exports = {"title":"RichText_title__5r7ua","richText":"RichText_richText__rFhX8"};